import { IProduct } from "src/core/products/api/products.api";
import {
  GTMItem,
  GTMItemOptionalQuantity
} from "src/library/utils/tagmanager-events/gtm-types";
import { IOrderLine } from "src/core/orders/api/orders.api";

import { unitPriceWithVAT } from "../../prices/utils/price-helpers";

export const productToGTMItem = (product: IProduct, gtmOverrides?: Partial<GTMItemOptionalQuantity>): GTMItemOptionalQuantity => {
  return ({
    item_id: product.partNumber as string,
    item_name: `${product.partNumber as string} - ${product.description}`,
    currency: "GBP",
    price: product.prices?.length ? product.prices[ 0 ].price : undefined,
    item_category: product?.categories?.length ? product.categories[ 0 ].name : undefined,
    ...gtmOverrides
  });
};

export const orderLineToGTMItem = (orderLine: IOrderLine, gtmOverrides?: Partial<GTMItem>): GTMItem => {
  return ({
    item_id: orderLine.product.partNumber as string,
    item_name: `${orderLine.product.partNumber as string} - ${orderLine.product.description}`,
    currency: "GBP",
    quantity: orderLine.quantity,
    price: unitPriceWithVAT(orderLine),
    ...gtmOverrides
  });
};
